import WairTracker from 'wair-tracker'
import { globalState } from '@/store'

function reportAction(defaultConfig, actionParams) {
  const actionSdk = new WairTracker(
    {
      reportUrl: '/log/collector/someaction',
      debug: false,
      enableWebClickEvent: false,
    },
    {
      app_name: 'chat-taichu-web',
      user_id: globalState.userInfo.id,
      href: window.location.href,
      ...defaultConfig,
    },
  )
  actionSdk.track(actionParams)
}

export default reportAction
